import { render } from "./Users.vue?vue&type=template&id=d5176986&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=d5176986&lang=scss&scoped=true"

import exportComponent from "/Applications/projects/bas-taj-korak-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5176986"]])

export default __exports__